import axios from "axios";

export const getAllUsers = async () => {
  const payload = {
    operation: "getAllActiveUsers",
    username: "admin_user",
    request: {
      searchTerm: ""
    }
  };

  try {
    const apiUrl = `${process.env.REACT_APP_PROXY_URL}/v1/get-all-users`;
    const response = await axios.post(
      apiUrl, payload,
      {
        headers: {
          Authorization: "Basic " + process.env.REACT_APP_AUTHORIZATION_KEY,
          "x-merck-apikey": process.env.REACT_APP_X_MERCK_API_KEY,
        },
      },
    );
    return response.data;
  } catch (e) {
    return null;
  }
};
